import './styles.scss'

import { useState } from 'react'
import { MinusOutlined, PlusOutlined } from '@ant-design/icons'
import { Form, Radio } from 'antd'

interface CollapsedRadioProps {
  dataSrc: Record<string, unknown>[]
  className?: string
  style?: React.CSSProperties
  expandIcon?: boolean
  formName?: string
  initialValue?: string
}

export default function CollapsedRadio({
  dataSrc,
  className,
  style,
  expandIcon,
  formName,
  initialValue,
}: CollapsedRadioProps) {
  const [selectedValue, setSelectedValue] = useState(1)

  const renderExpandIcon = (_icon, children = null, selectedValue_) => {
    if (children) {
      return (
        <div className="checkbox-accordion__radio__expand__icon">
          {selectedValue_ === selectedValue ? <MinusOutlined /> : <PlusOutlined />}
        </div>
      )
    }

    return null
  }

  const renderContent = (data) => (
    <Radio.Group
      className={`checkbox-accordion__wrapper ${className}`}
      style={style}
      onChange={(e) => setSelectedValue(e.target.value)}
    >
      {data.map((item) => (
        <Radio
          key={item.value}
          className="checkbox-accordion__radio"
          value={item.value}
        >
          <div className="checkbox-accordion__radio__icon">{item.icon}</div>
          <div className="checkbox-accordion__radio__name">{item.label}</div>
          {expandIcon
            && renderExpandIcon(expandIcon, item.children, item.value)}
          {selectedValue === item.value && item.children
            ? (
              <div className="checkbox-accordion__radio__expand active">
                {item.children}
              </div>
            )
            : <div className="checkbox-accordion__radio__expand" />}
        </Radio>
      ))}
    </Radio.Group>
  )

  const renderCheckList = () => {
    return formName !== ''
      ? (
        <Form.Item initialValue={initialValue} name={formName}>
          {renderContent(dataSrc)}
        </Form.Item>
      )
      : (
        renderContent(dataSrc)
      )
  }

  return <>{renderCheckList(dataSrc)}</>
}
